import { render } from "./ReviewsSection.vue?vue&type=template&id=6cffe954&scoped=true&ts=true"
import script from "./ReviewsSection.vue?vue&type=script&lang=ts"
export * from "./ReviewsSection.vue?vue&type=script&lang=ts"

import "./ReviewsSection.vue?vue&type=style&index=0&id=6cffe954&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cffe954"]])

export default __exports__